// extracted by mini-css-extract-plugin
module.exports = {"Navbar":"CustomNavbar_Navbar__3FHX4","Nav":"CustomNavbar_Nav__1qQBG","Dropdown":"CustomNavbar_Dropdown__fn_84"};